import * as Mustache from 'mustache';
import $ from 'jquery';
import 'url-polyfill'; // so we can do new URL().
import 'qtip2';
import 'qtip2/dist/jquery.qtip.min.css';

import { addFactHoverQtip } from '../factHover/factHoverTooltip';
import { IDocumentData } from './DocumentData';
import { IFrameMessageData } from './IFrameMessageData'
import { getExcelAddInProxy } from '../../shared/excelAddinProxy/calcbenchExcelAddInProxy';
import {
    ApproximateFactClass, ExactFactClass, NonXBRLFactHoverClass, NonXBRLFactIDAttribute, XBRLFactIdAttribute,
} from '../constants';
import { RemoteFunctions } from './RemoteFunctions';

/**
 *  Table user is hovering over.
 * */
const hoveredTableClass = 'CBHoveredTable'
const exportSinglePeriodID = 'exportSinglePeriod';
const exportFormulasID = 'exportFormulas'
const tableToolTipHTML = `
    <div class="tableextractdiv">
        <span>
            <img src="/Content/images/excel-logo.svg" class="tableHoverExcelLogo" />
            <a href="" class="tableExtract" id="${exportSinglePeriodID}" title="Export this table as an Excel file">Export</a>
        </span>
        {{#exportFormulas}}
        <span>
            <img src="/Content/images/excel-logo.svg" class="tableHoverExcelLogo" />
            <a href="" class="tableExtract" id="${exportFormulasID}" title="Export this table with formulas for the Calcbench Excel Add-in">Export Formulas</a>
        </span>
        {{/exportFormulas}}
        {{#allHistory}}
        <span>
            <img src="/Content/images/excel-logo.svg" class ="tableHoverExcelLogo" />
            <a href="" class="tableExtract" id="exportHistory" title="Export all of the history for this table">Export History</a>
        </span>
        {{/allHistory}}
    </div>
    `;

setup();


/**
 * Setup the tooltip
 * @returns
 */
function setup() {
    const metaDataText = $('#cbDocumentMetaData').text();
    const metaData: IDocumentData = metaDataText !== 'undefined' && JSON.parse(metaDataText);
    if (!metaData) {
        return;
    }
    const { calcbenchUser } = metaData;
    const { accessionID } = metaData;
    const { blobID } = metaData;
    const { inExcel } = metaData;
    const { nonXBRL } = metaData;
    const xbrlDocument = !nonXBRL;
    const { targetOrigin } = metaData;
    const { filingType } = metaData;
    const peerGroupURLParams = metaData.peerGroup;
    const calcbenchExcelAddInProxy = getExcelAddInProxy();

    $(document).ready(() => {
        /**
         * Find "real tables", they should have more than one row.  This could be more complicated.
         * */
        const realTables = $('table').filter((_, t) => $(t).find('tr').length > 1);
        realTables.qtip({
            content: {
                text: buildTableTooltip,
            },
            hide: {
                delay: 250,
                fixed: true,
            },
            position: {
                my: 'bottom center',
                at: 'top center',
                viewport: $('#iframecontent'),
                adjust: {
                    method: 'flip',
                    resize: true,
                },
            },
            events: {
                show(_, api:any) {
                    api.elements.target[0].classList.add(hoveredTableClass)
                },
                hide(_, api:any) {
                    api.elements.target[0].classList.remove(hoveredTableClass)
                }
            }
        });
        realTables.addClass('CBRealTable');

    });

    if (!calcbenchExcelAddInProxy) {
        // eslint-disable-next-line func-names
        $(document).on('mouseover', `.${ExactFactClass}`, function (event: Event) {
            const factID = $(event.target).closest(`[data-${XBRLFactIdAttribute}]`).data(XBRLFactIdAttribute);
            const nonXBRLFactID = parseInt($(event.target).closest(`[data-${NonXBRLFactIDAttribute}]`).data(NonXBRLFactIDAttribute));
            addFactHoverQtip($(this), factID, nonXBRLFactID ? NonXBRLFactHoverClass : 'XBRLFactHover', nonXBRLFactID, event, peerGroupURLParams, calcbenchUser, targetOrigin, metaData.sec_filing_id);
           });


        if (xbrlDocument) {
            // eslint-disable-next-line func-names
            $(document).on('mouseover', `.${ApproximateFactClass}`, function (event: Event) {
                addFactHoverQtip($(this), null, null, null, event, metaData.peerGroup, calcbenchUser, targetOrigin);
            });
        }
    }

    /**
     * Send a message to the hosting page.  These are handled in the setUpIFrameMessageHandler method on TextDocumentDisplayController 
     * @param messageData
     */
    function postMessage(messageData: IFrameMessageData & IDocumentData) {
        window.parent.postMessage(messageData, targetOrigin);
    }


    /**
     * Show the Export/Export Table above the table.
     * @returns
     */
    function buildTableTooltip() {
        const $tbl = $(this);
        const networkID = $tbl.data('cbnetworkid');
        const cbFacts = $tbl.find(`[data-cbfactid]`);
        const cbNonXBRLFacts = $tbl.find(`[data-cbextfactid]`);
        const $div = $(Mustache.render(tableToolTipHTML, {
            allHistory: networkID || (nonXBRL && calcbenchUser?.isNonGAAPAndGuidanceUser && (filingType === 1 || (filingType >= 3 && filingType <= 9))),
            exportFormulas: cbFacts.length > 0 || cbNonXBRLFacts.length > 0
        }));

        $div.find(`#${exportSinglePeriodID}`).unbind('click').click(event => {
            event.preventDefault();
            if (!metaData.inExcelTraceWindow) {
                const messageData = {
                    ...{
                        remoteFunctionName: RemoteFunctions.exportHTMLTable,
                        tableHTML: $tbl.html(),
                    } as IFrameMessageData,
                    ...metaData,
                };
                postMessage(messageData);
            }
        });

        $div.find(`#${exportFormulasID}`).off('click').on('click', event => {
            event.preventDefault();
            if (!metaData.inExcelTraceWindow) {
                const messageData = {
                    ...{
                        remoteFunctionName: RemoteFunctions.exportHTMLTable,
                        tableHTML: $tbl.html(),
                        exportFormulas: true
                    } as IFrameMessageData,
                    ...metaData,
                };
                postMessage(messageData);
            }
        })

        $div.find('#exportHistory').unbind('click').click(event => { // all hist
            event.preventDefault();
            if (nonXBRL) {
                const referenceElement = $tbl.find(`[data-${NonXBRLFactIDAttribute}]`);
                const referenceFactId = referenceElement.data(NonXBRLFactIDAttribute);
                const messageData = {
                    ...{
                        tableHTML: $tbl.html(),
                        blobID,
                        remoteFunctionName: RemoteFunctions.nonXBRLtableHistory,
                        referenceFactId,
                    } as IFrameMessageData,
                    ...metaData,
                };
                postMessage(messageData);
            } else if (!inExcel) {
                const messageData = {
                    ...{
                        accessionID,
                        networkID,
                        remoteFunctionName: RemoteFunctions.exportXBRLTableAllHistory,
                    },
                    ...metaData,
                };
                postMessage(messageData);
            }
        });


        /*
        * called by the Excel Add-in
        */
        (<any>window.parent).TableDataForExcelTrace = function () {
            return JSON.stringify({
                tableHTML: $tbl ? `<table>${$tbl.html()}</table>` : null,
                isNonXBRL: nonXBRL,
                accessionID,
                networkID,
            });
        };
        return $div;
    }
}